import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-800 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Section */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/9a009cd5-3ff0-4ca1-ac1e-1e65aa6f6699.png" 
                alt="ProGarage Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-2xl font-bold text-white">Segmentna Vrata</span>
            </div>
            
            <div className="flex items-center space-x-4">
              <div className="flex-1">
                <input
                  type="email"
                  placeholder="Vaš email za novosti"
                  className="w-full px-4 py-3 rounded-lg bg-slate-700 border border-slate-600 text-white placeholder-slate-400 focus:outline-none focus:border-red-500"
                />
              </div>
              <button className="bg-red-600 hover:bg-red-700 p-3 rounded-lg transition-colors">
                <i className="ri-notification-line text-white"></i>
              </button>
            </div>
            
            <p className="text-slate-300 text-lg leading-relaxed">
              Vaš pouzdani partner za<br />
              kvalitetna segmentna vrata
            </p>
          </div>

          {/* Right Section - Four Columns */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="text-white font-semibold mb-4">
                <Link to="/navigacija" className="hover:text-red-400">Navigacija</Link>
              </h4>
              <ul className="space-y-2 text-slate-300">
                <li><Link to="/" className="hover:text-white transition-colors">Početna</Link></li>
                <li><Link to="/usluge" className="hover:text-white transition-colors">Usluge</Link></li>
                <li><Link to="/galerija" className="hover:text-white transition-colors">Galerija</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold mb-4">
                <Link to="/informacije" className="hover:text-red-400">Informacije</Link>
              </h4>
              <ul className="space-y-2 text-slate-300">
                <li><Link to="/o-vratima" className="hover:text-white transition-colors">O Vratima</Link></li>
                <li><Link to="/kontakt" className="hover:text-white transition-colors">Kontakt</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold mb-4">
                <Link to="/kontakt" className="hover:text-red-400">Kontakt</Link>
              </h4>
              <ul className="space-y-2 text-slate-300 text-sm">
                <li>
                  <a href="tel:+381111234567" className="hover:text-white transition-colors">
                    +381 60 0706 072
                  </a>
                </li>
                <li>
                  <a href="mailto:stefan@segmentna-vrata.rs" className="hover:text-white transition-colors">
                    stefan@segmentna-vrata.rs
                  </a>
                </li>
                
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold mb-4">Radno Vreme</h4>
              <ul className="space-y-1 text-slate-300 text-sm">
                <li>Pon - Pet: 08:00 - 18:00</li>
                <li>Subota: 09:00 - 15:00</li>
                <li>Nedelja: Zatvoreno</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-slate-700 mt-12 pt-8 flex flex-col lg:flex-row items-center justify-between">
          <p className="text-slate-400 text-sm">
            © 2024 SegmentnaVrata. Sva prava zadržana.
          </p>

          <div className="flex items-center space-x-6 mt-4 lg:mt-0">
            <a href="#" className="w-10 h-10 border border-slate-600 rounded-lg flex items-center justify-center text-slate-400 hover:text-white hover:border-red-500 transition-colors">
              <i className="ri-facebook-line"></i>
            </a>
            <a href="#" className="w-10 h-10 border border-slate-600 rounded-lg flex items-center justify-center text-slate-400 hover:text-white hover:border-red-500 transition-colors">
              <i className="ri-instagram-line"></i>
            </a>
            <a href="#" className="w-10 h-10 border border-slate-600 rounded-lg flex items-center justify-center text-slate-400 hover:text-white hover:border-red-500 transition-colors">
              <i className="ri-linkedin-line"></i>
            </a>
            <a href="#" className="w-10 h-10 border border-slate-600 rounded-lg flex items-center justify-center text-slate-400 hover:text-white hover:border-red-500 transition-colors">
              <i className="ri-youtube-line"></i>
            </a>
          </div>

          
        </div>
      </div>
    </footer>
  );
};

export default Footer;